import { IconToggleButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, useCallback } from "react"

import { useEditorFocused, useFallbackEditor, useSubscriptState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface SubscriptToggleButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconToggleButton>, "children">, OptionalEditorProps {}

export const SubscriptToggleButton = memo<SubscriptToggleButtonProps>((props) => {
	const { ref, editor: editorFromProps, pressed, onPressedChange, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const isEditorFocused = useEditorFocused(editor)
	const state = useSubscriptState(editor)

	const handlePressedChange = useCallback(
		(pressed: boolean) => {
			onPressedChange?.(pressed)
			editor?.chain().focus().toggleSubscript().run()
		},
		[editor, onPressedChange],
	)

	return (
		<IconToggleButton
			ref={ref}
			pressed={pressed ?? (state.isActive && isEditorFocused)}
			onPressedChange={handlePressedChange}
			disabled={disabled ?? !state.canToggle}
			{...rest}
		>
			<LuIcon icon={tipTapIconMapping.subscript} />
		</IconToggleButton>
	)
})
SubscriptToggleButton.displayName = "SubscriptToggleButton"
